import Vue from 'vue';
import Component from 'vue-class-component';
import customCampaignQuery from 'assets/graphql/queries/campaign/CustomCampaign.graphql';
import BannerNavidad from 'assets/images/BannerNavidad2024.png';
import BannerNavidadRegion from 'assets/images/BannerNavidad2024_region.png';

import CustomCampaignCover from 'components/Campaign/CustomCampaignCover';
import CustomCampaignBoxes from 'components/Campaign/CustomCampaignBoxes';
import CustomCampaignActivities from 'components/Campaign/CustomCampaignActivities';
import CustomCampaignTravelActivities from 'components/Campaign/CustomCampaignTravelActivities';
import updateHeaderAndFooter from 'utils/updateHeaderAndFooter';
import getLastTld from 'common/services/utils/getLastTld';

@Component({
  apollo: {
    custom_campaign: {
      query: customCampaignQuery,
      variables() {
        return {
          campaign_slug: this.$route.params.campaignSlug,
        };
      },
      result({ data }) {
        this.campaignBoxesFlag =
          data.custom_campaign.custom_campaign_boxes?.length > 0;
        this.campaignActivitiesFlag =
          data.custom_campaign.custom_campaign_activities?.length > 0;
        updateHeaderAndFooter(
          data.custom_campaign?.show_main_header,
          data.custom_campaign?.show_main_footer,
        );
      },
    },
  },
  components: {
    CustomCampaignCover,
    CustomCampaignBoxes,
    CustomCampaignActivities,
    CustomCampaignTravelActivities,
  },
  metaInfo() {
    if (!this.custom_campaign) return {}; // Wait for the campaign data to load

    const canonicalUrl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname;

    // Determine the description content and limit it to 155 characters
    let descriptionContent = [
      this.custom_campaign.subtitle,
      this.custom_campaign.box_title,
      this.custom_campaign.experiences_title,
    ]
      .filter(Boolean)
      .join('. ')
      .substring(0, 155);

    return {
      title: `${this.custom_campaign.title} - Regalos Bigbox`, // Set the page title
      meta: [
        {
          name: 'description',
          content: descriptionContent, // Set the description from campaign.subtitle
          vmid: 'description',
        },
        {
          property: 'og:title',
          content: `${this.custom_campaign.title} - Regalos Bigbox`, // OG title
          vmid: 'ogTitle',
        },
        {
          property: 'og:description',
          content: descriptionContent, // OG description
          vmid: 'ogDescription',
        },
        {
          property: 'og:image',
          content: this.custom_campaign.cover_image, // Set the cover image
          vmid: 'ogImage',
        },
        {
          property: 'og:url',
          content: window.location.href, // Current page URL
          vmid: 'ogUrl',
        },
        {
          property: 'og:type',
          content: 'product',
          vmid: 'ogType',
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: canonicalUrl, // Set the canonical URL without query parameters
          vmid: 'canonical',
        },
      ],
    };
  },
})
export default class BaseCustomCampaignComponent extends Vue {
  campaignBoxesFlag = false;
  campaignActivitiesFlag = false;
  currentCountry = getLastTld();

  get isChristmasLanding() {
    const slug = this.$route.params.campaignSlug;
    return ['Navidad', 'navidad_mx', 'navidad_pe', 'navidad_uy'].includes(slug);
  }

  get christmasProductsLanding() {
    const slugMap = {
      Navidad: 'productos-navidenos-argentina',
      navidad_mx: 'productos-navidenos-mexico',
      navidad_pe: 'productos-navidenos-peru',
      navidad_uy: 'productos-navidenos-uruguay',
    };
    return {
      name: 'new-custom-landing',
      params: { landingSlug: slugMap[this.$route.params.campaignSlug] },
    };
  }

  get christmasImage() {
    return ['cl', 'pe'].includes(this.currentCountry)
      ? BannerNavidadRegion
      : BannerNavidad;
  }

  get christmasTexts() {
    return ['cl', 'mx', 'pe'].includes(this.currentCountry)
      ? 'Acompaña estas Fiestas con nuestra selección de productos.'
      : 'Hacé brillar tu mesa navideña con nuestra selección de productos.';
  }

  get travelActivities() {
    const filteredValue =
      this.custom_campaign.custom_campaign_activities.filter(item => {
        return item.__typename === 'TravelActivityType';
      });
    return filteredValue;
  }
  destroyed() {
    updateHeaderAndFooter();
  }
}
